import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService, GrowlType } from '../../../infrastructure/services/alert.service';
import { SxHttpService } from '../../../infrastructure/services/sxHttp.service';
import { debug } from 'util';
import { File64 } from '../sxFileImport/file64.interf';
import { AzureFile } from 'app/infrastructure/model/interfaces/azureFile.Interface';
import { Translator } from 'angular-translator';

@Component({
    selector: 'list-filesmanager',
    templateUrl: 'listFilesManager.component.html'
})
export class ListFileManagerComponent implements OnInit {
    public search: string;
    codSistema: string;
    preguntarSiDeseaBorrar = [];
    @Input() azureFiles: AzureFile[] = [];
    @Input() isSelector: boolean = false;
    selectedFolderType: string = null;
    customFolder: string = null;
    folderTypes = [
        'Documents',
        'Reports',
        'Catalogs',
        'Custom'
    ];

    supported: string[] = ['.json', '.xlsx', '.docx', '.html', '.txt', '.pdf'];

    file64: File64 = null;
    file: any = null;
    filename: string = null;

    constructor(private router: Router,
        private aRoute: ActivatedRoute,
        private alertService: AlertService,
        private sxHttp: SxHttpService,
        private translate: Translator) { }

    ngOnInit() {
        this.aRoute.params.subscribe(params => {
            this.codSistema = params['codsistema'];
        });
    }

    selectFolder(folderType) {
        this.selectedFolderType = folderType;
    }

    uploadFile() {
        const folder = this.getFolder();
        if (!folder) {
            return;
        }

        let fileToUpload: any;
        let url = ``;
        url = `api/azurefilemanager/PostAzureFileManager`;
        fileToUpload = {
            systemCode: this.codSistema,
            fileName: this.filename,
            folder: folder,
            file: this.file
        };

        if (!this.file) {
            this.alertService.showGrowl({
                type: GrowlType.DANGER,
                body: 'SOC_FE_0001_ERROR',
            });

            return;
        }

        this.sxHttp.post(url, fileToUpload)
            .toPromise()
            .then(response => {
                this.file = null;
                this.filename = null;
                this.getFiles();
            });
    }

    uploadTransform() {
        const folder = this.getFolder();
        if (!folder) {
            return;
        }

        let fileToUpload: any;
        let url = ``;

        url = `api/azurefilemanager/PostAzureFileManagerConvert`;
        if (!this.isdocx()) {
            this.alertService.showGrowl({
                type: GrowlType.DANGER,
                body: 'SOC_FE_0003_FILE_MUST_BE_DOCX',
            });
            return;
        }

        fileToUpload = {
            codSistema: this.codSistema,
            fileName: this.filename,
            folder: folder,
            file: this.file
        };

        if (!this.file) {
            this.alertService.showGrowl({
                type: GrowlType.DANGER,
                body: 'SOC_FE_0002_MUST_SELECT_A_FILE',
            });

            return;
        }

        this.sxHttp.post(url, fileToUpload)
            .toPromise()
            .then(response => {
                this.file = null;
                this.filename = null;
                this.getFiles();
            });
    }

    getFolder(): any {
        let folder = this.selectedFolderType;
        if (!folder) {
            this.alertService.showGrowl({
                type: GrowlType.DANGER,
                body: 'SOC_FE_0004_FOLDER_EMPTY',
            });
            return null;
        }
        if (folder === 'Custom') {
            if (!this.customFolder) {
                this.alertService.showGrowl({
                    type: GrowlType.DANGER,
                    body: 'SOC_FE_0005_CUSTOM_FOLDER_PATH_EMPTY',
                });
                return null;
            }
            folder = this.customFolder;
        }
        return folder;
    }

    getFiles() {
        const folder = this.getFolder();

        if (!folder) {
            return;
        }
        const url = `api/azurefilemanager/${this.codSistema}/${folder}`;
        this.sxHttp.get(url).map(response => {
            return response.json().data as AzureFile[];
        }).subscribe(data => {
            this.azureFiles = data;
        });
    }

    theFileChosen(imp: File64) {
        this.file64 = imp;
        this.filename = this.file64.fileName;
        this.file = imp.fileData;
    }

    isdocx(): boolean {
        if (this.filename.split('.').pop().replace(/^/, '.') === '.docx') {
            return true;
        }
        return false;
    }

    volver() {
        this.router.navigate(['../'], { relativeTo: this.aRoute });
    }

    trimSASUrlFile(url: string) {
        const index = url.indexOf('?');

        if (index > 0) {
            return url.substring(0, index);
        }

        return url;
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/listFilesManager/listFilesManager.component.ts